import React from "react";
import {
  Box,
  Container,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  img: {
    margin: "auto",
    display: "block",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "42%",
    },
    [theme.breakpoints.down("lg")]: {
      maxWidth: "52%",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95%",
    },
    maxHeight: "100%",
  },
}));

const NotAccessView = ({
  enableGlobalLoader,
  disableGlobalLoader,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Nieuprawniony dostęp">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Box mb={1}>
            <Alert severity="error" className={classes.massagebox}>
              <AlertTitle>
                <strong>Nieuprawniony dostęp</strong>
              </AlertTitle>
              <div>
                Nastąpiła próba dostepu do zasobów systemu bez posiadania
                niezbędnych uprawnień. System rejestruje takie próby.
              </div>
            </Alert>
            <Box my={2}>
              <Button
                component={RouterLink}
                to="/"
                color="primary"
                fullWidth
                size="large"
                type="button"
                variant="contained"
              >
                Strona główna
              </Button>
            </Box>
          </Box>
        </Container>
        <Box display="flex" alignItems="flex-end" flexGrow={1} p={1}>
          <Box display="flex" flexDirection="column">
            <img
              className={classes.img}
              alt="Logo UE stopka"
              src="/static/images/logo_ue_main.jpg"
            />
            <Typography
              variant="caption"
              gutterBottom
              color="textSecondary"
              align="center"
              component="p"
            >
              Aplikacja współfinansowana przez Unię Europejską ze środków
              Europejskiego Funduszu Społecznego w ramach Regionalnego Programu
              Operacyjnego Województwa Podlaskiego na lata 2014-2020
            </Typography>
            <Typography
              color="textPrimary"
              variant="subtitle2"
              align="center"
              component="p"
            >
              2021 © Urząd Marszałkowski Województwa Podlaskiego
            </Typography>
          </Box>
        </Box>
      </Box>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(null, mapDispatchToProps)(NotAccessView);
